/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { PlatformConfig } from "../../models/platformConfig.ts";

import { customMutator } from "../../../mutators/custom-mutator.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getPlatformConfigResponse200 = {
  data: PlatformConfig;
  status: 200;
};

export type getPlatformConfigResponseSuccess = getPlatformConfigResponse200 & {
  headers: Headers;
};
export type getPlatformConfigResponse = getPlatformConfigResponseSuccess;

export const getGetPlatformConfigUrl = () => {
  return `/api/platform-config`;
};

/**
 * This deployment's settings the browser needs, the same for every caller.
 * @summary Get Platform Config
 */
export const getPlatformConfig = async (
  options?: RequestInit,
): Promise<getPlatformConfigResponse> => {
  return customMutator<getPlatformConfigResponse>(getGetPlatformConfigUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPlatformConfigQueryKey = () => {
  return [`/api/platform-config`] as const;
};

export const getGetPlatformConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformConfig>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPlatformConfig>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlatformConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformConfig>>
  > = ({ signal }) => getPlatformConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlatformConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformConfig>>
>;
export type GetPlatformConfigQueryError = unknown;

export function useGetPlatformConfig<
  TData = Awaited<ReturnType<typeof getPlatformConfig>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformConfig>>,
          TError,
          Awaited<ReturnType<typeof getPlatformConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlatformConfig<
  TData = Awaited<ReturnType<typeof getPlatformConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformConfig>>,
          TError,
          Awaited<ReturnType<typeof getPlatformConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlatformConfig<
  TData = Awaited<ReturnType<typeof getPlatformConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Platform Config
 */

export function useGetPlatformConfig<
  TData = Awaited<ReturnType<typeof getPlatformConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPlatformConfigQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Platform Config
 */
export const prefetchGetPlatformConfigQuery = async <
  TData = Awaited<ReturnType<typeof getPlatformConfig>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetPlatformConfigQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};
